export default __webpack_public_path__ + "static/media/dashboard-alt-dark.3e72d784.png";